// eslint-disable-next-line import/no-extraneous-dependencies
import gql from 'graphql-tag';

// eslint-disable-next-line import/extensions
import { FRAGMENT_IMAGE_BRAND, FRAGMENT_BRAND_REVIEW_ITEM } from './apolloFragment.js';

export const GET_POPULAR_COLLECTIONS = gql`
  query getPopularCollections ($slug: String!) {
    brand {
      popularCollections(slug: $slug) {
        total
        list {
          image
          name
          slug
          url
        }
      }
    }
  }
`;

export const GET_BRAND_DATA = gql`
  ${FRAGMENT_IMAGE_BRAND}
  query getBrandData ($slug: String!) {
    brand {
      topBanner(slug: $slug) {
        title
        description
        logo {
          ...fragmentImageBrand
        }
        bgLogo {
          ...fragmentImageBrand
        }
      }
      rating (slug: $slug) {
        count
        rating
        hasImages
      }
    }
  }
`;

export const GET_COLLECTION_DATA = gql`
  ${FRAGMENT_IMAGE_BRAND}
  query getCollectionData ($slug: String!) {
    brandCollection {
      topBanner(slug: $slug) {
        title
        brandTitle
        description
        brandSlug
        brandUrl
        bgImage {
          ...fragmentImageBrand
        }
      }
    }
  }
`;

export const GET_BRAND_REVIEWS = gql`
  ${FRAGMENT_BRAND_REVIEW_ITEM}
  query getBrandReviews (
    $slug: String!,
    $pageId: Int,
    $sortMode: ReviewSortModeEnum,
   ) {
    brand {
      reviews (
        slug: $slug,
        pageId: $pageId,
        sortMode: $sortMode,
      ){
        ...fragmentBrandReviewItem
      }
    }
   }
`;
